import { defineFieldFormInterface } from "~/entities/field";
import InterfaceDatetimeDatetimeType from "./InterfaceDatetimeDatetimeType.vue";

export default defineFieldFormInterface({
  interface: "datetime",
  type: "dateTime",
  component: InterfaceDatetimeDatetimeType,
});

